import { Typography } from "@mui/material";

const UsersPage = () => {
  return <Typography variant="h4">Ayarlar Sayfası</Typography>;
};

export default UsersPage;